document.addEventListener('DOMContentLoaded', (event) => {
    var productDescription = document.getElementById("product_description");
    if (productDescription) {
        console.log("Description loaded");
        var productDescriptionHtml = productDescription.innerHTML;
        const sections = [
            { className: 'ProductDescriptionTop', target: '.product-description-top' },
            { className: 'ProductPackageInfo', target: '.product-package-info' },
            { className: 'ProductDescriptionBottom', target: '.product-description-bottom' },
            { className: 'TableServingsHeading', target: '.product-TableServingsHeading' },
            { className: 'ProductNutritionTable', target: '.table-and-product-features' },
            { className: 'compare-pro', target: '.product-productCompareTable' },
            { className: 'whats_included', target: '.product-whatsIncludedHeading' }
        ];

        // Function to handle the insertion of description content when target is available
        function processSection(section) {
            const targetElement = document.querySelector(section.target);
            if (targetElement) {
                const descriptionContents = getContentByClassName(productDescriptionHtml, section.className);
                descriptionContents.forEach(content => {
                    targetElement.insertAdjacentHTML('beforeend', content);
                });
                return true;
            }
            return false;
        }

        // Attempt to process each section
        sections.forEach(processSection);
        if (document.querySelector('.ProductFeatures')) updateProductFeatures();
        if (document.querySelector("#product_description .whats_included")) updateIncludedItems();
        
        if (document.querySelector('.ProductNutritionTable')) {
            document.querySelector('.product-ProductNutritionTable').classList.remove('hidden');
        }
        updatePageInternalLinks()
    } else {
        console.log("Got Issue while loading Description");
    }

    // This code is using to update price for mobile on variant change
    // Currently we are using same targets with id two time so we remove desktop target on mobile screen
    // On live site they are not updating value on variant change
    if (window.innerWidth < 768) {
        let priceContainer = document.querySelector('.js--desktop-price');
        if (priceContainer) {
            priceContainer.remove();
        }
    }
});

function getContentByClassName(htmlString, className) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');
    const elements = doc.querySelectorAll('.' + className);
    return Array.from(elements).map(el => el.outerHTML);
}

function updateProductFeatures() {
    var Features = document.querySelector('.ProductFeatures').innerHTML.split(",");
    if(Features != ''){
        for (var i = 0; i < Features.length; i++) {
            var li = document.createElement('li');
            li.innerHTML = '<i class="fa fa-check" aria-hidden="true"></i> ' + Features[i];
            document.querySelector('ul.product-features').appendChild(li);
        }
    }
}

function updatePageInternalLinks() {
    if (document.querySelector('#included.included-main')) {
        document.querySelector('.whats_included--li-link').classList.remove('hidden');
    }
    if(document.querySelector("#product_description .ProductFeatures")) {
        document.querySelector('.product_features--li-link').classList.remove('hidden');
        document.querySelector('.product-productCompareTable').classList.remove('hidden');
    }
}

function updateIncludedItems() {

    // Get the text content of the element with class ProductServingItemsList.
    var includesText = document.querySelector('.ProductServingItemsList').textContent;
    // Split the text content by ',' to get an array.
    var includes = includesText.split(',');
    window.items = [];
    window.servings = [];
    window.drinkheader = 0;
    window.entreeheader = 0;
    window.sidedishheader = 0;
    window.soupheader = 0;
    window.breakfastheader = 0;
    for (var i = 0; i < includes.length; i++) {
        window.servings.push(includes[i].substring(5));
        window.items.push(includes[i].substring(5, -1));
    }

    fetch('/pages/included-foods')
        .then(response => response.text()) // Get the response text (HTML content)
        .then(html => {
            // Create a temporary element to parse the HTML string
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, "text/html");
            // Select the #IncludedFoods part from the parsed HTML
            const includedFoods = doc.querySelector('#IncludedFoods');
            if (includedFoods) {
                // If the element exists, update the #ProductContents on the page
                document.getElementById('ProductContents').innerHTML = includedFoods.innerHTML;

                document.querySelectorAll('.nutri-info-block').forEach(function (element) {
                    let itemImg = window.shopifyAssetUrls.itemImg,
                        incBorder = window.shopifyAssetUrls.incBorder;
                    let itemcode = element.getAttribute('id').replace('nutri-info-', '').trim();
                    const hasItemCode = window.items.some(item => item.includes(itemcode));

                    if (hasItemCode) {
                        const itemIndex = window.items.findIndex(item => item.includes(itemcode));
                        const servings = window.servings[itemIndex].replace("-", "");
                        const itemname = element.querySelector('h2').textContent;

                        var li = `
                                <li>
                                    <span style="background-image: url(${itemImg}); 
                                                background-size: 476px 665px;" 
                                            id="img-disp-${itemcode}" 
                                            class="item-photo">
                                        <a class="p1" href="#nutr-info" id="${itemcode}">
                                        <img width="95" height="95" alt="" src="${incBorder}">
                                        <b>CLICK FOR INFO</b>
                                        </a>
                                    </span>
                                    <span class="item-name" id="${itemcode}">${itemname}</span>
                                    <span class="item-servings">
                                        (<span id="servings-disp-${itemcode}">${servings}</span> Servings)
                                    </span>
                                </li>`;

                        const leftPart = document.querySelector('.left-part');

                        if (itemcode.match(/BK/)) {
                            window.itemtype = "Breakfast";
                            window.itemclass = "break-fast";
                            if (window.breakfastheader === 0) {
                                leftPart.insertAdjacentHTML('beforeend', `<div class="${window.itemclass}"><h6>${window.itemtype}s Included</h6><ul class="breakfastlist"></ul></div>`);
                                window.breakfastheader = 1;
                            }
                            document.querySelector('.breakfastlist').insertAdjacentHTML('beforeend', li);
                        } else if (itemcode.match(/ET/) || itemcode.match(/SP/) || itemcode.match(/MT/)) {
                            window.itemtype = "Entree";
                            window.itemclass = "entree";
                            if (window.entreeheader === 0) {
                                leftPart.insertAdjacentHTML('beforeend', `<div class="${window.itemclass}"><h6>${window.itemtype}s Included</h6><ul class="entreelist"></ul></div>`);
                                window.entreeheader = 1;
                            }
                            document.querySelector('.entreelist').insertAdjacentHTML('beforeend', li);
                        } else if (itemcode.match(/SD/)) {
                            window.itemtype = "Side";
                            window.itemclass = "side-dish";
                            if (window.sidedishheader === 0) {
                                leftPart.insertAdjacentHTML('beforeend', `<div class="${window.itemclass}"><h6>${window.itemtype}s Included</h6><ul class="sidedishlist"></ul></div>`);
                                window.sidedishheader = 1;
                            }
                            document.querySelector('.sidedishlist').insertAdjacentHTML('beforeend', li);
                        } else if (itemcode.match(/DM/)) {
                            window.itemtype = "Drink";
                            window.itemclass = "drink-mix";
                            if (window.drinkheader === 0) {
                                leftPart.insertAdjacentHTML('beforeend', `<div class="${window.itemclass}"><h6>${window.itemtype}s Included</h6><ul class="drinklist"></ul></div>`);
                                window.drinkheader = 1;
                            }
                            document.querySelector('.drinklist').insertAdjacentHTML('beforeend', li);
                        } else {
                            //console.log('');
                        }

                        element.querySelector('.servings span').textContent = servings;
                        document.querySelector('.right-part').appendChild(element);
                    }
                });


                // Make first child visible
                let firstNutriBlock = document.querySelector('.right-part div:first-child');
                if (firstNutriBlock) {
                    firstNutriBlock.style.display = 'block';
                }

                // Code for hover and click events on items
                document.querySelectorAll('.left-part li').forEach(function (item) {
                    let itemPhoto = item.querySelector('.item-photo');

                    itemPhoto.onmouseover = function () {
                        itemPhoto.querySelector('b').classList.add('overthumb');
                    };

                    itemPhoto.onmouseout = function () {
                        itemPhoto.querySelector('b').classList.remove('overthumb');
                    };

                    itemPhoto.onclick = function () {
                        let currcode = this.id.replace('img-disp-', '');
                        document.querySelectorAll('.nutri-info-block').forEach(block => block.style.display = 'none');
                        document.querySelector('#included #nutri-info-' + currcode).style.display = 'block';
                    };
                });

                // Update background image for ProductSprites
                document.querySelectorAll('.ProductSprites').forEach(function (sprite) {
                    sprite.style.backgroundImage = 'url(' + window.shopifyAssetUrls.itemImg + ')';
                });


                console.log("Content loaded successfully!");
            } else {
                console.error("Element '#IncludedFoods' was not found in the loaded content.");
            }
        })
        .catch(error => {
            // Handle any errors that occurred during fetch
            console.error('Error loading content:', error);
        });
}